import { CharField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import type { Keyword } from "../../types"
import { WysiwygField } from "../../components/WysiwygField"

export default function KeywordForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<Keyword>()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <CharField
        label="Nome"
        layout="horizontal"
        value={values.name}
        onChange={(value) => {
          setFieldValue("name", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "name") : undefined}
        errorMessage={getIn(errors, "name")}
        required
      />

      <WysiwygField
        label="Descrizione"
        layout="horizontal"
        value={values.description || ""}
        onChange={(value) => {
          setFieldValue("description", value)
        }}
      />
    </Col>
  )
}
